"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBrainOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.67 20.21a5 5 0 001-7.55A4.73 4.73 0 0029 11a5 5 0 00-5-5 4.48 4.48 0 00-8-2.29A4.48 4.48 0 008 6a5 5 0 00-5 5 4.73 4.73 0 00.3 1.66 5 5 0 001 7.55 4.61 4.61 0 00-.15.53c0 .1-.06.19-.08.3A5 5 0 009 27h.13A4 4 0 0016 28.62 4 4 0 0022.87 27H23a5 5 0 004.9-6c0-.11-.06-.2-.08-.3a4.61 4.61 0 00-.15-.49zM13 28a2 2 0 01-2-2v-1H9a3 3 0 01-3-3 3.1 3.1 0 010-.54v-.15a2.52 2.52 0 01.12-.39v-.13A3 3 0 019 19v-2a5 5 0 00-3.58 1.52 2.95 2.95 0 01-.29-4.84l.65-.52-.4-.74A3 3 0 015 11a3 3 0 013-3h2V6.5a2.5 2.5 0 015 0V8a4 4 0 01-4 4v2a6 6 0 004-1.54V18a2 2 0 01-2 2v2a3.91 3.91 0 002-.56V26a2 2 0 01-2 2zm10-3h-2v1a2 2 0 01-4 0v-4.56a3.91 3.91 0 002 .56v-2a2 2 0 01-2-2v-5.54A6 6 0 0021 14v-2a4 4 0 01-4-4V6.5a2.5 2.5 0 015 0V8h2a3 3 0 013 3 3 3 0 01-.38 1.42l-.4.73.65.53a2.95 2.95 0 01-.29 4.84A5 5 0 0023 17v2a3 3 0 012.74 1.79s0 .09.05.13a2.52 2.52 0 01.12.39v.15A3.1 3.1 0 0126 22a3 3 0 01-3 3z" })));
}
exports.default = SvgBrainOutline;
//# sourceMappingURL=BrainOutline.js.map